
'use strict';

var _win = $(window);



$(_win).on('load',function() {
   $('#tab-accordion-0').prop("checked", true);
});